import { CatalogsService } from '../../../services/catalogs/catalogs.service';
import { RegimenFiscalService } from '../../../services/regimen-fiscal/regimen-fiscal.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/map';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';

@Component({
  selector: 'app-add-modal',
  templateUrl: './add-modal.component.html',
  styleUrls: ['./add-modal.component.scss'],
  providers: [CatalogsService, RegimenFiscalService]
})
export class AddRegimenFiscalModalComponent implements OnInit {

  public user: User;
  loading: boolean = false;
  closeResult: string;
  titulo = '';
  btnText = '';
  row: any;
  sociedades: any[] = [];
  sociedadFiltro: any;
  sociedadObj: {} = {};
  noRegimenFiltro: any;
  descRegimenFiltro: any;
  flagEditar: boolean = false;

  constructor(
    private storageService: StorageService,
    private regimenFiscalService: RegimenFiscalService,
    private CatalogsService: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.user = this.storageService.getCurrentUser();
    this.getSociedades();

    if (this.row) {
      this.flagEditar = true;
      this.sociedadFiltro = this.row.claveSociedad;
      this.noRegimenFiltro = this.row.noRegimen;
      this.descRegimenFiltro = this.row.descRegimenFiscal;
    }

    (this.flagEditar) ? this.titulo = this.translate.instant('texto.editarLabel') : this.titulo = this.translate.instant('texto.registrarLabel');
    (this.flagEditar) ? this.btnText = this.translate.instant('texto.editarLabel') : this.btnText = this.translate.instant('texto.registrarLabel');
  }

  closeModal() {
    this.activeModal.close('');
  }

  getSociedades() {
    this.CatalogsService.obtenerSociedades().subscribe(
      data => {
        this.sociedades = data.sapSociedad;
      },
      err => {
      },
    );
  }
 
  customSearchFn(term: string, item) { 
    term = term.toLowerCase();
    let rfc = String(item.rfc)
    return rfc.toLowerCase().indexOf(term) > -1 || item.sociedad.toLowerCase() === term || item.razonSocial.toLowerCase() === term;
  }

  sociedadSelected(e) {
    if (e) {
      this.sociedadObj = e;
    }
  }

  validarRegistro() {
    (this.flagEditar) ? this.editarRegimenFiscal() : this.guardarRegimenFiscal();
  }

  guardarRegimenFiscal() {
    this.loading = true;
    this.regimenFiscalService.postRegimenFiscal(this.noRegimenFiltro, this.descRegimenFiltro, this.sociedadObj['rfc'], this.sociedadObj['sociedad']).subscribe(
      data => {;
        this.loading = false;
        let response = data.result;

        if (response.estatus === 'S') {
          this.toasterService.pop('success', '', response.mensaje);
          this.activeModal.close('success');
        } else {
          this.toasterService.pop('error', 'Error', response.mensaje);
        }
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

  editarRegimenFiscal() {
    let sociedadRFC = (this.sociedadObj['sociedad']) ? this.sociedadObj['sociedad'] : this.sociedadFiltro;
    let rfcRFC = (this.sociedadObj['rfc']) ? this.sociedadObj['rfc'] : this.sociedadFiltro;

    let obj = {
      "regimenFiscal": {
        "id": this.row.id,
        "noRegimen": this.noRegimenFiltro,
        "descRegimenFiscal": this.descRegimenFiltro,
        "rfcSociedad": rfcRFC,
        "claveSociedad": sociedadRFC
       }
    }

    this.loading = true;
    this.regimenFiscalService.updateRegimenFiscal(obj).subscribe(
      data => {;
        this.loading = false;
        let response = data.result;

        if (response.estatus === 'S') {
          this.toasterService.pop('success', '', response.mensaje);
          this.activeModal.close('success');
        } else {
          this.toasterService.pop('error', 'Error', response.mensaje);
        }
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/regimen-fiscal/add-modal/add-modal.component.ts